import builder from '../builder';
import NavigationMenu from '../../streamline-icons/bold/navigation-menu.svg';

export default builder('IconNavigationMenuBold', NavigationMenu);
